import React from 'react';
import Typography from '@mui/material/Typography';

import type { IShowing } from 'src/api/landlord-showings-api';
import type { ILead } from 'src/services/api';
import ExpandableItem from 'src/components/lead-sidebar/LeadSidebarExpandableItem';
import Tour from 'src/components/lead-sidebar/LeadSidebarTour';

interface Props {
    lead: ILead,
    showings: IShowing[],
}

export default function LeadSidebarPastTours({
    lead,
    showings,
}: Props) {
    const pastShowings = showings.filter((showing) => {
        return showing.lead_uuid === lead.uuid && showing.start_time < new Date().toISOString();
    });

    return (
        <ExpandableItem
            title="Past Tours"
            defaultExpanded
        >
            {pastShowings.length > 0 ? (
                pastShowings.map((showing) => (
                    <Tour
                        key={showing.id}
                        lead={lead}
                        showing={showing}
                        color="primary.main"
                    />
                ))
            ) : (
                <Typography variant="body2" color="grey">No Past tours</Typography>
            )}
        </ExpandableItem>
    );
}
